<app-table
  [actionColumnWidth]="1400"
  [columns]="columns"
  [loading]="loading"
  [value]="serviceAccounts"
  filename="MENU.SERVICE_ACCOUNTS">
  <ng-template
    (onClick)="createServiceAccount()"
    appToolbarButton
    icon="fal fa-plus"
    labelKey="SERVICE_ACCOUNTS.CREATE_SERVICE_ACCOUNT"></ng-template>

  <ng-template
    (onClick)="showClientSecret($event.row, $event.event, overlayPanel)"
    appActionButton
    icon="fal fa-lock-open"
    labelKey="SERVICE_ACCOUNTS.SHOW_CLIENT_SECRET"></ng-template>

  <ng-template
    (onClick)="deactivateServiceAccount($event.row)"
    appActionButton
    displayIf="enabled"
    icon="fal fa-pause"
    labelKey="SERVICE_ACCOUNTS.DEACTIVATE_ACCOUNT"
    type="warning"></ng-template>

  <ng-template
    (onClick)="activateServiceAccount($event.row)"
    appActionButton
    displayIfNot="enabled"
    icon="fal fa-play"
    labelKey="SERVICE_ACCOUNTS.ACTIVATE_ACCOUNT"
    type="warning"></ng-template>

  <ng-template
    (onClick)="deleteServiceAccount($event.row)"
    appActionButton
    icon="fal fa-trash"
    labelKey="SERVICE_ACCOUNTS.DELETE_ACCOUNT"
    type="danger"></ng-template>

  <ng-template
    (onClick)="resetClientSecret($event.row)"
    appActionButton
    displayIf="enabled"
    icon="fal fa-undo"
    labelKey="SERVICE_ACCOUNTS.RESET_CLIENT_SECRET"
    type="warning"></ng-template>

  <ng-template
    (onClick)="showConfiguration($event.row)"
    appActionButton
    icon="fal fa-file-alt"
    labelKey="SERVICE_ACCOUNTS.SHOW_CONFIG"></ng-template>
</app-table>

<p-popover #overlayPanel>
  @if (clientSecret) {
    <pre style="display: inline-block">{{ clientSecret.value }}</pre>
    &nbsp;
    <p-button
      [appCopyClipboard]="clientSecret.value"
      [title]="'ACTIONS.COPY' | translate"
      icon="fal fa-copy"
      type="button"></p-button>
  }
</p-popover>

<p-dialog
  [(visible)]="showConfigurationModal"
  [baseZIndex]="10000"
  [draggable]="false"
  [header]="'SERVICE_ACCOUNTS.CONFIGURATION' | translate"
  [modal]="true"
  [resizable]="false"
  [style]="{ width: '75vw' }">
  @if (showConfigurationModal) {
    <pre class="configuration">
      <code class="language-yaml"
            pCode>{{ configuration }}</code>
    </pre>
  }
  <p-footer>
    <p-button
      [appCopyClipboard]="configuration"
      [label]="'ACTIONS.COPY' | translate"
      icon="fal fa-copy"
      type="button"></p-button>
    <p-button
      (onClick)="downloadConfiguration()"
      [label]="'ACTIONS.DOWNLOAD' | translate"
      icon="fal fa-download"
      type="button"></p-button>
    <p-button
      (onClick)="showConfigurationModal = false"
      [label]="'ACTIONS.CLOSE' | translate"
      icon="fal fa-times"
      type="button"></p-button>
  </p-footer>
</p-dialog>
